/**
 * Some LLM backends double-escape line breaks when generating a JSON string value, so
 * JSON.parse correctly decodes it into the literal two-character sequence `\` `n` sitting in
 * the string as visible text rather than an actual line break — see
 * lambda/utils/processor/normalize-literal-escape-sequences-in-job.ts for the source-side fix
 * applied to newly extracted jobs. This is the same repair applied at display time, so records
 * indexed before that fix shipped (or a re-extraction reintroducing the artifact) still render
 * with real line breaks instead of visible "\n" text.
 */
export function normalizeLiteralEscapeSequences(text: string): string {
  return text
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\n')
    .replace(/\\t/g, '\t');
}
